// Percorso file: src/components/games/MenuEvento.jsx
//
// IL MENÙ DI UN GIOCATORE — cantiere GAMES, fetta G2, PIANO §3 «Eventi» e
// «Gesti»: si apre col TOCCO SINGOLO sul token e offre gol / giallo / rosso;
// il minuto lo mette l'app leggendo il cronometro (lo fa il padre, con le
// funzioni pure). Componente di PRESENTAZIONE dentro il guscio modale di
// AdminTools.css (la forma di `ModaleStato` in AttendanceSummary.jsx: velo,
// titolo, corpo, comandi), con le voci nel gruppo-scelta (`qpsc-btn-dark`).
//
// DUE CAUTELE, non nel PIANO ma dichiarate nel referto:
//   · il ROSSO (diretto o da 2º giallo) chiede una CONFERMA nello stesso
//     menù: espelle un giocatore per il resto della partita e non si
//     annulla dal campo (la tabella finale corregge le statistiche, non il
//     rientro). Gol e 1º giallo sono immediati: si correggono in tabella;
//   · in coda il menù porta anche «Move to pitch / Move to bench»: è la via
//     SENZA trascinamento (tastiera, o un dispositivo su cui il drag non
//     dovesse rispondere). Il gesto principale resta il trascinamento.
//
// (G3) «CLEAN»: in fondo, a parte e in veste di servizio (fantasma, non la
// voce scura degli eventi, perché non si prema al posto di un evento),
// azzera TUTTI gli eventi del giocatore aperto — gol, gialli, rosso → 0 —
// e, se era espulso, lo rimette fra i disponibili. Chiede una
// micro-conferma nello stesso menù, come il rosso. Compare solo se c'è
// qualcosa da pulire. Per un ESPULSO il menù offre SOLO «Clean»: eventi e
// spostamenti gli sono negati dalle regole (non rientra finché è espulso).
// Tutto in memoria: nessun disco, nessuna rete (lo fa il padre con
// `azzeraEventiGiocatore`).

import React, { useState } from "react";
import { FaArrowDown, FaArrowUp, FaEraser, FaFutbol, FaSquare } from "react-icons/fa";
import {
  eEspulso,
  eInCampo,
  minutoCorrente,
  prossimoGialloERosso,
  TIPI_EVENTO
} from "./regolePartita";
import "./GamesMatch.css";

export default function MenuEvento({
  giocatore,
  partita,
  adesso,
  onEvento,
  onSposta,
  onAzzera,
  onChiudi
}) {
  // "" | "red" | "second-yellow" | "clean": la conferma in attesa.
  const [conferma, setConferma] = useState("");

  const id = String(giocatore.id);
  const dentro = eInCampo(partita, id);
  const espulso = eEspulso(partita, id);
  const secondoGiallo = prossimoGialloERosso(partita, id);
  const minuto = minutoCorrente(partita.cron, adesso);
  const tempo = partita.cron.tempo === 1 ? "1H" : "2H";
  const daPulire = espulso || partita.eventi.some((e) => e.playerId === id);

  const registra = (tipo) => {
    onEvento(giocatore.id, tipo);
    onChiudi();
  };

  const pulisci = () => {
    onAzzera(giocatore.id);
    onChiudi();
  };

  const testoConferma = {
    "second-yellow": "Second yellow card: the player is sent off and cannot return.",
    red: "Red card: the player is sent off and cannot return.",
    clean: espulso
      ? "Clear all events for this player? Goals and cards go back to 0 and the player is available again."
      : "Clear all events for this player? Goals and cards go back to 0."
  };

  return (
    <div className="qpsc-modal-overlay" onClick={onChiudi}>
      <div
        className="qpsc-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="qpsc-games-menu-title"
        onClick={(e) => e.stopPropagation()}
      >
        <h2 className="qpsc-modal__title" id="qpsc-games-menu-title">
          {giocatore.nome}
        </h2>

        <div className="qpsc-modal__body">
          <p className="qpsc-games-menu__meta">
            {tempo} {minuto}&prime; &middot;{" "}
            {espulso ? "Sent off" : dentro ? "On pitch" : "On bench"}
          </p>

          {conferma && (
            <>
              <p
                className={
                  "qpsc-games-menu__confirm" +
                  (conferma === "clean" ? " qpsc-games-menu__confirm--clean" : "")
                }
              >
                {testoConferma[conferma]}
              </p>
              <div className="qpsc-modal__actions">
                <button type="button" className="qpsc-ghost-btn" onClick={() => setConferma("")}>
                  Back
                </button>
                <button
                  type="button"
                  className="qpsc-tool-btn"
                  onClick={() => {
                    if (conferma === "clean") pulisci();
                    else registra(conferma === "second-yellow" ? TIPI_EVENTO.GIALLO : TIPI_EVENTO.ROSSO);
                  }}
                >
                  Confirm
                </button>
              </div>
            </>
          )}

          {!conferma && !espulso && (
            <div className="qpsc-choice-group">
              <span className="qpsc-choice-group__label">Record</span>
              <div className="qpsc-choice-group__options qpsc-games-menu__options">
                <button
                  type="button"
                  className="qpsc-btn-dark"
                  onClick={() => registra(TIPI_EVENTO.GOL)}
                >
                  <span className="qpsc-games-menu__icon qpsc-games-menu__icon--goal">
                    <FaFutbol />
                  </span>
                  Goal
                </button>
                <button
                  type="button"
                  className="qpsc-btn-dark"
                  onClick={() =>
                    secondoGiallo ? setConferma("second-yellow") : registra(TIPI_EVENTO.GIALLO)
                  }
                >
                  <span className="qpsc-games-menu__icon qpsc-games-menu__icon--yellow">
                    <FaSquare />
                  </span>
                  {secondoGiallo ? "2nd yellow card (sent off)" : "Yellow card"}
                </button>
                <button
                  type="button"
                  className="qpsc-btn-dark"
                  onClick={() => setConferma("red")}
                >
                  <span className="qpsc-games-menu__icon qpsc-games-menu__icon--red">
                    <FaSquare />
                  </span>
                  Red card
                </button>
              </div>

              <span className="qpsc-choice-group__label">Without dragging</span>
              <div className="qpsc-choice-group__options qpsc-games-menu__options">
                <button
                  type="button"
                  className="qpsc-btn-dark"
                  onClick={() => {
                    onSposta(giocatore.id, !dentro);
                    onChiudi();
                  }}
                >
                  <span className="qpsc-games-menu__icon">
                    {dentro ? <FaArrowDown /> : <FaArrowUp />}
                  </span>
                  {dentro ? "Move to bench" : "Move to pitch"}
                </button>
              </div>
            </div>
          )}

          {/* (G3) «Clean», FUORI dal gruppo-scelta degli eventi e in veste
              fantasma: non si confonde con una voce. Solo se c'è qualcosa
              da pulire, e mai durante una conferma. */}
          {!conferma && daPulire && (
            <div className="qpsc-games-menu__clean">
              {espulso && (
                <p className="qpsc-games-menu__meta">
                  Sent off: no events or moves until the red card is cleared.
                </p>
              )}
              <button type="button" className="qpsc-ghost-btn" onClick={() => setConferma("clean")}>
                <FaEraser />
                Clean
              </button>
            </div>
          )}
        </div>

        {!conferma && (
          <div className="qpsc-modal__actions">
            <button type="button" className="qpsc-ghost-btn" onClick={onChiudi}>
              Cancel
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
